module.exports = __webpack_public_path__ + "6419ef0d99f491c6694d8af52bcbabf3.svg";